import React from 'react';
import Hero from '../components/Hero';
import CoursesSection from '../components/CoursesSection';
import TestimonialsSection from '../components/TestimonialsSection';
import Newsletter from '../components/Newsletter';

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-slate-50 text-slate-900">
      <Hero />
      <CoursesSection />
      <TestimonialsSection />
      <Newsletter />
    </main>
  );
};

export default Home;
